import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Chip from 'Chip';
import { NewsStream } from '@ifeng-fe/news-stream';
import '@ifeng-fe/news-stream/lib/NewsStream/style/news-stream-global.css';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import TopNews from './topNews';

class Content extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { recommend = [], newsstream = [], isEnd, columnId, recommendId } = this.props.content;

        return (
            <div className={styles.content}>
                <Chip
                    id={recommendId || '289434'}
                    type="recommend"
                    title="信息流推荐位"
                    groupName="信息流"
                    content={recommend}>
                    <TopNews />
                </Chip>
                <NewsStream content={newsstream} columnId={columnId} isEnd={isEnd} isDisplaySource={true} />
            </div>
        );
    }
}

export default errorBoundary(Content);
